document.addEventListener('DOMContentLoaded', () => {
  const customizer = document.getElementById('bs-open-btn');
  if (!customizer) return; // only runs on pages with the BS Photo Customizer

  const buyButtons = document.querySelector('.buy-buttons-block');
  if (buyButtons) buyButtons.style.display = 'none';
});
